import React from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "../../../../../utils/notifications";
import LoaiPhieuThuChiApi from "service/QuanTriHeThong/LoaiPhieuThuChi/LoaiPhieuThuChiApi";

export const ModalXoa = ({ show, onHide, item, onDeleted }) => {
    const [isActiveSubmit, setIsActiveSubmit] = React.useState(false);
    if (!item) return null;

    const deleteLoaiPhieu = async () => {
        setIsActiveSubmit(true);
        try {
            const response = await LoaiPhieuThuChiApi.delete(item.LoaiThuChiId);
            if (response.status === 200) {
                pushNotification("Xóa thành công!", "success", "TOP_CENTER", 2000);
                if (onDeleted) onDeleted();
            } else {
                pushNotification("Xóa thất bại!", "error", "TOP_CENTER", 2000);
            }
        } catch {
            pushNotification("Xóa thất bại!", "error", "TOP_CENTER", 2000);
        }
        setIsActiveSubmit(false);
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="modal-dialog"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title color7-bold" id="myModalLabel16">
                    <span className="btn-icon-right">
                       <i className="mdi mdi-delete" ></i>
                    </span>
                    Xác nhận xóa
                </h4>
                <button
                    type="button"
                    className="close-popup-new"
                    onClick={onHide}
                >
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="form form-horizontal">
                    <div className="form-body">
                        <div className="form-body text-center">
                            <p style={{fontSize: '16px'}}>Bạn có chắc chắn muốn xóa loại phiếu này?</p>
                            <p className="vertical-align-v2" style={{ color: 'rgb(255, 81, 112)' }}>Hành động này không thể hoàn tác.</p>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={onHide}
                >
                    <span>
                        <i className="mdi mdi-close"></i>
                    </span>
                    &nbsp; Hủy
                </button>

                <button 
                    type="button" 
                    className="btn btn-new-main btn-danger" 
                    onClick={deleteLoaiPhieu} 
                    disabled={isActiveSubmit}
                >
                    <span>
                        <i className="mdi mdi-delete" ></i>
                    </span>
                    &nbsp; Đồng ý xóa
                </button>
            </Modal.Footer>
        </Modal>
    );
};